"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _AlertFill = _interopRequireDefault(require("../../../icons/utils/AlertFill"));

var _NotificationFill = _interopRequireDefault(require("../../../icons/utils/NotificationFill"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var fillColor = function fillColor(_ref) {
  var variant = _ref.variant,
      theme = _ref.theme;
  if (variant === 'error') return theme.colors.system.error;
  if (variant === 'warning') return theme.colors.system.warning;
  return theme.colors.system.success;
};

var Heading = _styledComponents.default.h4.withConfig({
  displayName: "ModalHeading__Heading",
  componentId: "n6lom1-0"
})(["&&{background-color:", ";color:", ";margin:", ";position:relative;", "}svg{polygon{fill:", ";}rect{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary.primaryBlue;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.spacing.xlarge, " ").concat((0, _polished.rem)('75px'), " ").concat(theme.spacing.large, " ").concat(theme.spacing.xxxlarge);
}, function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return theme.media.medium((0, _styledComponents.css)(["margin:", ";padding-left:", ";"], function (_ref6) {
    var theme = _ref6.theme;
    return "".concat(theme.spacing.large, " ").concat((0, _polished.rem)('75px'), " ").concat(theme.spacing.large, " ").concat(theme.spacing.xxlarge);
  }, variant !== 'informational' ? (0, _polished.rem)('35px') : ""));
}, function (_ref7) {
  var variant = _ref7.variant,
      theme = _ref7.theme;
  return fillColor({
    variant: variant,
    theme: theme
  });
}, function (_ref8) {
  var variant = _ref8.variant,
      theme = _ref8.theme;
  return fillColor({
    variant: variant,
    theme: theme
  });
});

var iconBaseStyles = (0, _styledComponents.css)(["color:", ";display:block;margin-bottom:", ";", ""], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral.white;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.media.medium((0, _styledComponents.css)(["left:0;margin-bottom:inherit;position:absolute;top:", ";"], (0, _polished.rem)('5px')));
});

var _StyledNotificationFillIcon = (0, _styledComponents.default)(_NotificationFill.default).withConfig({
  displayName: "ModalHeading___StyledNotificationFillIcon",
  componentId: "n6lom1-1"
})(["", ""], iconBaseStyles);

var _StyledAlertFillIcon = (0, _styledComponents.default)(_AlertFill.default).withConfig({
  displayName: "ModalHeading___StyledAlertFillIcon",
  componentId: "n6lom1-2"
})(["", ""], iconBaseStyles);

var ModalHeading = function ModalHeading(_ref12) {
  var id = _ref12.id,
      variant = _ref12.variant,
      titleText = _ref12.titleText;
  return /*#__PURE__*/_react.default.createElement(Heading, {
    id: id,
    variant: variant
  }, function () {
    switch (variant) {
      case 'error':
      case 'success':
        return /*#__PURE__*/_react.default.createElement(_StyledNotificationFillIcon, null);

      case 'warning':
        return /*#__PURE__*/_react.default.createElement(_StyledAlertFillIcon, null);

      default:
        return '';
    }
  }(), titleText);
};

ModalHeading.defaultProps = {
  variant: 'informational'
};
ModalHeading.propTypes = {
  /** _Required_ Child content rendered inside Modal. */
  titleText: _propTypes.default.string.isRequired,

  /** _Required_ id used for aria purposes. */
  id: _propTypes.default.string.isRequired,

  /** _Optional_ prop that sets variant style for error, success, and warning messages; supports `[informational(default)|error|success|warning]`. */
  variant: _propTypes.default.oneOf(['informational', 'error', 'success', 'warning'])
};
var _default = ModalHeading;
exports.default = _default;
//# sourceMappingURL=ModalHeading.js.map